import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import "./Register.css";

function Register() {
  const [schoolName, setSchoolName] = useState();
  const [schoolEmailID, setSchoolEmailID] = useState();
  const [schoolLoginID, setSchoolLoginID] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    const payload = {
      schoolName: schoolName,
      schoolEmailID: schoolEmailID,
      schoolLoginID: schoolLoginID,
      password: password,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/register`, payload)
      .then((res) => {
        setLoading(false);
        toast("School Registration Successful");
        console.log("School Registered", res);
      })
      .catch((err) => {
        toast("Registration Failed");
        console.log("Error while reiteration", err);
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="justify-content-center align-items-center text-center register-container">
        <div className="bg-white p-3 rounded">
          <h2 className="mb-3 text-primary">Register</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3 text-start">
              <label htmlFor="schoolname" className="form-label">
                <strong>School Name</strong>
              </label>
              <input
                type="text"
                placeholder="Enter Name"
                className="form-control"
                id="exampleInputname"
                onChange={(event) => setSchoolName(event.target.value)}
                required
              />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="schoolemailid" className="form-label">
                <strong>School Email Id</strong>
              </label>
              <input
                type="email"
                placeholder="Enter Email"
                className="form-control"
                id="exampleInputEmail1"
                onChange={(event) => setSchoolEmailID(event.target.value)}
                required
              />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="loginid" className="form-label">
                <strong>School Login Id</strong>
              </label>
              <input
                type="text"
                placeholder="Enter School Login Id"
                className="form-control"
                id="exampleInputLoginID"
                onChange={(event) => setSchoolLoginID(event.target.value)}
                required
              />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="exampleInputPassword1" className="form-label">
                <strong>Password</strong>
              </label>
              <input
                type="password"
                placeholder="Enter Password"
                className="form-control"
                id="exampleInputPassword1"
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>
            <button
              disabled={loading}
              type="submit"
              className="btn btn-primary w-full disabled:opacity-70 py-2 px-4 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
            >
              {loading ? "Submitting.." : "Register"}
            </button>
          </form>

          <p className="container my-2">Already have an account ?</p>
          <Link to="/erp/login" className="btn btn-secondary">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Register;
